module.exports = __webpack_public_path__ + "img/cicon1.533c0e29.png";